<template>
  <div class="static-content">
    <div class="products">
      <div class="section-title">{{ $t('productTitle') }}</div>
      <div class="product-banner">
        <img src="@/assets/image/activity/coupon-in-hand.png" class="coupon-image">
        <div class="banner-left">
          <div class="title">{{ $t('newUserPrivilege') }}</div>
          <div class="detail">
            <span class="percentage"> 20% </span>
            <span class="term">{{ $t('newTerm') }}</span>
          </div>
          <div class="tip">{{ $t('newTip') }}</div>
        </div>
        <div class="banner-right">
          <div>{{ $t('go') }}</div>
        </div>
      </div>
      <div class="product-item" v-for="(item, index) in productList" :key="index">
        <div class="product-name">
          <div class="text">{{ item.name }}</div>
          <img v-if="item.showTag" src="@/assets/image/activity/tag-hot.png" class="tag-hot">
        </div>
        <div class="product-detail">
          <div class="left">
            <span class="percentage">{{ item.percentage }}</span>
            <span class="term">{{ item.term }}</span>
          </div>
          <div class="right">
            <md-button type="primary" round plain @click="toInvest">
              {{ $t('invest') }}
            </md-button>
          </div>
        </div>
        <div class="product-tip">
          <div class="tip-inner">
            <div> {{ item.tip }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="about-us">
      <div class="section-title">{{ $t('aboutUsTitle') }}</div>
      <div class="about-us-item" v-for="(item, index) in aboutUsList" :key="index">
        <div class="about-us-header">
          <img class="icon" :src="item.icon">
          <div class="title">{{ item.title }}</div>
        </div>
        <div class="about-us-detail">{{ item.detail }}</div>
      </div>
    </div>
    <activity-footer></activity-footer>
  </div>
</template>

<script>
import ActivityFooter from '@/components/activity/ActivityFooter'
import { Button } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        productTitle: 'Recommended for you',
        newUserPrivilege: 'New User Privilege',
        newTerm: '7 Days',
        newTip: 'New user can use it for once',
        fixedProduct: 'Fixed Term Funding',
        go: 'Go',
        fixedTerm: '30 Days',
        fixedTip: 'Start from Rp 10.000',
        invest: 'INVEST',
        flexibleProduct: 'Flexible Funding',
        flexibleTerm: 'Withdraw Anytime',
        flexibleTip: 'Higher than bank deposit',
        investTip: 'Please register/login first',
        aboutUsTitle: 'About Us',
        aboutTitle1: 'Registered & Monitored',
        aboutDesc1: 'PT Kredit Pintar Indonesia (Kredit Pintar) is a Peer-to-Peer platform registered with OJK (Financial Services Authority) with the aim of providing funding to high-quality users.',
        aboutTitle2: 'Transparency',
        aboutDesc2: 'Funds provided by lenders will be managed in a registered "Escrow Account" where funds are directly channeled to users (borrowers). You can see who matches your money every day, and easily manage your account through our dashboard.',
        aboutTitle3: 'Managed Risk',
        aboutDesc3: 'In minimizing credit risk, preventing default, and monitoring real-time operational conditions, our platform uses a maximum risk control system of big data and model fraud score.',
        aboutTitle4: 'Market Leader',
        aboutDesc4: 'Kredit Pintar is one of the leading Peer-to-Peer platforms in Indonesia. This can be seen from our popularity and lending activities in our Kredit Pintar application, as well as active in the Indonesian Fintech Association.',
      },
      id: {
        productTitle: 'Rekomendasi untuk Anda',
        newUserPrivilege: 'Khusus Pengguna Baru',
        newTerm: '7 Hari',
        newTip: 'Dapat digunakan sekali untuk pengguna baru',
        fixedProduct: 'Pendanaan Berjangka',
        go: 'Go',
        fixedTerm: '30 Hari',
        fixedTip: 'Mulai dari Rp 10.000',
        invest: 'Coba',
        flexibleProduct: 'Pendanaan Fleksibel',
        flexibleTerm: 'Tarik Kapanpun',
        flexibleTip: 'Lebih tinggi dari deposito bank',
        investTip: 'Harap daftar/masuk dahulu',
        aboutUsTitle: 'Tentang Kami',
        aboutTitle1: 'Terdaftar & Diawasi',
        aboutDesc1: 'PT Kredit Pintar Indonesia (Kredit Pintar) adalah platform Peer-to-Peer yang terdaftar di OJK (Otoritas Jasa Keuangan) dengan tujuan memberikan pendanaan kepada pengguna yang berkualitas tinggi.',
        aboutTitle2: 'Transparansi',
        aboutDesc2: 'Dana yang disediakan oleh pendana akan dikelola di "Rekening Escrow" terdaftar di mana dana secara langsung disalurkan ke pengguna. Anda dapat melihat siapa yang cocok dengan uang Anda setiap hari, dan dengan mudah mengelola akun Anda melalui dashboard kami.',
        aboutTitle3: 'Resiko Terkelola',
        aboutDesc3: 'Dalam meminimalkan resiko pinjaman, mencegah kegagalan, dan memantau kondisi operasional real-time, platform kami menggunakan sistem pengendalian resiko maksimum dari big data dan model skor penipuan.',
        aboutTitle4: 'Market Leader',
        aboutDesc4: 'Kredit Pintar adalah salah satu platform Peer-to-Peer terkemuka di Indonesia. Hal ini dapat dilihat dari popularitas dan kegiatan pendanaan kami di aplikasi Kredit Pintar, serta Kredit Pintar aktif di Asosiasi Fintech Indonesia.',
      },
    },
  },
  components: {
    ActivityFooter,
    [Button.name]: Button,
  },
  data() {
    return {
      productList: [
        {
          name: this.$t('fixedProduct'),
          showTag: true,
          percentage: '12%',
          term: this.$t('fixedTerm'),
          tip: this.$t('fixedTip'),
        },
        {
          name: this.$t('flexibleProduct'),
          showTag: false,
          percentage: '9%',
          term: this.$t('flexibleTerm'),
          tip: this.$t('flexibleTip'),
        },
      ],
      aboutUsList: [
        {
          icon: require('../../assets/image/activity/icon-about-us-1.png'),
          title: this.$t('aboutTitle1'),
          detail: this.$t('aboutDesc1'),
        },
        {
          icon: require('../../assets/image/activity/icon-about-us-2.png'),
          title: this.$t('aboutTitle2'),
          detail: this.$t('aboutDesc2'),
        },
        {
          icon: require('../../assets/image/activity/icon-about-us-3.png'),
          title: this.$t('aboutTitle3'),
          detail: this.$t('aboutDesc3'),
        },
        {
          icon: require('../../assets/image/activity/icon-about-us-4.png'),
          title: this.$t('aboutTitle4'),
          detail: this.$t('aboutDesc4'),
        },
      ],
    }
  },
  methods: {
    toInvest() {
      this.$toast.info(this.$t('investTip'))
    },
  },
}
</script>

<style lang="stylus" scoped>
.static-content {
  background: color-primary;
}

.section-title {
  text-align: center;
  font-size: 20px;
  color: #fff;
  margin-bottom: 30px;
}

.products, .about-us {
  padding: 0 24px 24px;
}

.products {
  .product-banner {
    position: relative;
    background-image: url('../../assets/image/activity/bg-coupon.png');
    background-size: 100% 100%;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    .coupon-image {
      position: absolute;
      width: 68px;
      height: 86px;
      left: -6px;
      bottom: 14px;
    }
    .banner-left {
      margin-left: 76px;
      font-size: 12px;
      .title {
        color: #fffac4;
        font-weight: 500;
      }
      .detail {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 2px;
        .percentage {
          font-size: 20px;
          font-weight: bold;
          font-style: italic;
          color: #fff36e;
          margin-right: 8px;
          /*background-color: rgba(255, 255, 255, 1) linear-gradient(180deg, rgba(255, 251, 200, 1) 0%, rgba(255, 243, 110, 1) 100%);*/
        }
        .term {
          color: #FE8C00;
          padding: 0 8px;
          background-image: url('../../assets/image/activity/bg-term.png');
          background-size: 100% 100%;
        }
      }
      .tip {
        color: #fff;
        margin-top: 5px;
      }

    }
    .banner-right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: #fff;
      font-size: 16px;
      margin-right: 24px;
      font-weight: bold;
    }
  }
  .product-item {
    background-color: #fff;
    border-radius: 6px;
    margin: 10px 0;
    padding: 15px 24px;
    .product-name {
      font-size: 14px;
      font-weight: 500;
      color: #555;
      line-height: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .tag-hot {
        margin-left: 10px;
        width: 28px;
        height: 12px;
      }
    }
    .product-detail {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 18px 0 10px;
      .percentage {
        font-size: 26px;
        font-weight: bold;
      }
      .term {
        font-size: 12px;
        font-weight: bold;
        line-height: 26px;
        margin-left: 12px;
      }
      .right /deep/ {
        .md-button {
          width: auto;
        }
      }
    }
    .product-tip {
      display: flex;
      justify-content: flex-start;
      .tip-inner {
        color: color-primary;
        font-size: 12px;
        line-height: 16px;
        padding: 4px 8px;
        font-style: normal;
        background-color: #E8FADC;
        transform: skew(-10deg);
        div {
          transform: skew(10deg);
        }
      }
    }
  }
}

.about-us {
  .about-us-item {
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.08);
    margin-bottom: 15px;
    &:last-child {
      margin: 0;
    }
    .about-us-header {
      padding: 14px 0 10px;
      background-color: #F5F5F5;
      border-radius: 6px 6px 0 0;
      text-align: center;
      .icon {
        width: 36px;
        height: 36px;
      }
      .title {
        color: #555;
        line-height: 20px;
      }
    }
    .about-us-detail {
      padding: 24px;
      font-size: 12px;
      line-height: 20px;
      color: #888;
    }
  }
}
</style>
